import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import AtosService from '../../../../../services/ato-auth';
import { Link } from 'react-router-dom';



const FormBusca = (props) => {
    const [palavra, setPalavra] = useState("");
    const [categoria, setCategoria] = useState("");



    const busca = async (query) => {
        if (query === "") {
            await props.fetchAtosIn()
            setPalavra("")
            setCategoria("")
        } else {
            var response = await AtosService.buscar(query)
            if (response.data.length >= 1) {
                props.setAtos(response.data)
                props.setVazio(false)
                setPalavra("")
                setCategoria("")
            } else {
                props.setVazio(true)
                setPalavra("")
                setCategoria("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (categoria !== "false" && categoria !== "") prepQuery = prepQuery + `categoria=${encodeURI(categoria)}`;
        if (palavra) prepQuery = prepQuery + `&palavra=${encodeURI(palavra)}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={4}>
                        <Col xs={12} lg={5}>
                            <Form.Group className="mb-3" controlId="Categoria">
                                <FloatingLabel
                                    label="Categoria"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Categoria"
                                        name="categoria"
                                        onChange={e => setCategoria(e.target.value)}
                                    >
                                        <option value="false">TODAS</option>
                                        <option value="Despacho">Despacho</option>
                                        <option value="Ofício">Ofício</option>
                                        <option value="Memorando">Memorando</option>
                                        <option value="Processo Administrativo">Processo Administrativo</option>
                                        <option value="Ofício Circular">Ofício Circular</option>
                                        <option value="Despacho de Encaminhamento">Despacho de Encaminhamento</option>
                                        <option value="Decisão">Decisão</option>
                                        <option value="Decreto">Decreto</option>
                                        <option value="Instrução Normativa">Instrução Normativa</option>
                                        <option value="Ato Administrativo Não Especificado">Ato Administrativo Não Especificado</option>
                                        <option value="Lei Ordinária">Lei Ordinária</option>
                                        <option value="Lei Complementar">Lei Complementar</option>
                                        <option value="Laudo">Laudo</option>
                                        <option value="Laudo Pericial">Laudo Pericial</option>
                                        <option value="Íntegra de Processo Administrativo">Íntegra de Processo Administrativo</option>
                                        <option value="Ações de Governo">Ações de Governo</option>
                                        <option value="Decisão Judicial">Decisão Judicial</option>
                                        <option value="Processo Judicial">Processo Judicial</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={5}>
                            <Form.Group className="mb-3" controlId="Palavra-chave">
                                <FloatingLabel
                                    label="Palavra-chave"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="palavra"
                                        value={palavra}
                                        onChange={e => setPalavra(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/restrito/atos'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca
